<div>
  <div *ngIf="!logoError">
    <img [src]="dealerLogo" alt="Dealer Logo" *ngIf="!isLogoLoading; else noDealerLogo" width="200" />
    <ng-template #noDealerLogo>Loading Logo...</ng-template>
  </div>
  <div *ngIf="logoError">No dealer logo</div>
</div>
